import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
   
    routes: [
        {
            path: '/',
            component: () => import('@/view/homepage/index')
        }, {
            path: '/home',
            name: 'home',
            component: () => import('@/view/homepage/index')
        }, {
            path: '/login',
            name: 'login',
            component: () => import('@/view/homepage/login')
        }, {
            path: '/register',
            name: 'register',
            component: () => import('@/view/homepage/register')
        },
        // 展会展品
        {
            path: "/contactUs",
            name: 'contactUs',
            component: () => import('@/view/exhibitorManagement/index')
        },
        {
            path: '/publishexhibits',
            name: 'publishexhibits',
            component: () => import('@/view/exhibitorManagement/publishexhibits')
        },
        // 展会详情
        {
            path: '/exhibitmeet',
            name: '展会详情',
            component: () => import('@/view/exhibitorManagement/exhibitmeet')
        },
        {
            path: '/exhibitsample',
            name: '展品详情',
            component: () => import('@/view/exhibitorManagement/exhibitsample')
        },
        {
            path: '/myExhibition/:id?',
            name: 'myExhibition',
            component: () => import('@/view/exhibitorManagement/myExhibition')
        },
       
            // 展会中心
        {
            path: '/exhibitionCenter',
            name: 'exhibitionCenter',
            component: () => import('@/view/exhibitionCenter/index')
        }, 
        {
            path: '/calendardetail',
            name: 'calendardetail',
            component: () => import('@/view/exhibitionCenter/calendardetail')
        }, 
        {
            path: '/domesticExhibition',
            name: 'domesticExhibition',
            component: () => import('@/view/exhibitionCenter/domesticExhibition')
        }, 
        //国际展会
        {
            path: '/internationalExhibition',
            name: 'internationalExhibition',
            component: () => import('@/view/exhibitionCenter/internationalExhibition')
        },
        //展会详情、展会简介
        {
            path: '/exhibitmeetdetail',
            name: 'exhibitmeetdetail',
            component: () => import('@/view/exhibitionCenter/exhibitionDetail')
        },
            //线下论坛
        {
            path: '/offlineBBS',
            name: 'offlineBBS',
            component: () => import('@/view/exhibitionCenter/offlineBBS')
        }, {
            path: '/signUp',
            name: 'signUp',
            component: () => import('@/view/exhibitionCenter/signUp')
        }, {
            path: '/groupList',
            name: 'groupList',
            component: () => import('@/view/exhibitionCenter/groupList')
        }, {
            path: '/groupDetails',
            name: 'groupDetails',
            component: () => import('@/view/exhibitionCenter/groupDetails')
        }, {
            path: '/boothOrder',
            name: 'boothOrder',
            component: () => import('@/view/exhibitionCenter/boothOrder')
        }, {
            path: '/ticketReservation',
            name: 'ticketReservation',
            component: () => import('@/view/exhibitionCenter/ticketReservation')
        }, {
            path: '/myInformation',
            name: 'myInformation',
            component: () => import('@/view/homepage/myInformation')
        }, {
            path: '/myExhibitions',
            name: 'myExhibitions',
            component: () => import('@/view/homepage/myExhibition')
        }, {
            path: '/reportExhibition',
            name: 'reportExhibition',
            component: () => import('@/view/homepage/reportExhibition')
        }, {
            path: '/myFocus',
            name: 'myFocus',
            component: () => import('@/view/homepage/myFocus')
        }, {
            path: '/myGroup',
            name: 'myGroup',
            component: () => import('@/view/homepage/myGroup')
        }, {
            path: '/groupDetail',
            name: 'groupDetail',
            component: () => import('@/view/homepage/groupDetail')
        }, {
            path: '/myExhibits',
            name: 'myExhibits',
            component: () => import('@/view/homepage/myExhibits')
        },
        // news 展会资讯
         {

            path: '/news',
            name: 'news',
            component: () => import('@/view/information/index')
        }, {
            path: '/newsDetail',
            name: 'newsDetail',
            component: () => import('@/view/information/newsDetail')
        },
        //  会展中心
        {
            path: '/conventionCenter',
            name: 'conventionCenter',
            component: () => import('@/view/conventionCenter/index')
        },
        {
            path: '/conventionCenterdetail',
            name: 'conventionCenterdetail',
            component: () => import('@/view/conventionCenter/detail')
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js